import React from 'react';
import { SvgIcon } from "@mui/material";
import { Primary } from "../../../constants/colors";

{/* eslint-disable max-len */
}

const size = 32;
const fontSize = "medium";
const viewBoxValue = `0 0 ${size} ${size}`;

export const LocationIcon = () => {
  return (
    <SvgIcon width={size} height={size} fontSize={fontSize} viewBox={viewBoxValue}>
      <g transform="translate(2 2)" fill="none" fillRule="evenodd">
        <circle stroke={Primary} strokeWidth="3" fill="#FFF" cx="14" cy="14" r="14"/>
        <path
          d="M13.92 9.448a2.49 2.49 0 0 0-2.485 2.48 2.49 2.49 0 0 0 2.482 2.493 2.49 2.49 0 0 0 2.486-2.48 2.49 2.49 0 0 0-2.483-2.493m-5.964 2.546c.01-1.505.48-2.84 1.475-3.98a5.861 5.861 0 0 1 3.3-1.927 5.791 5.791 0 0 1 1.938-.07 5.837 5.837 0 0 1 3.199 1.45c.952.847 1.585 1.892 1.86 3.138.243 1.098.231 2.193-.163 3.262-.198.537-.484 1.032-.787 1.516-.738 1.182-1.555 2.31-2.35 3.454-.62.892-1.244 1.78-1.862 2.674-.16.23-.366.369-.65.368a.684.684 0 0 1-.585-.293c-.407-.576-.81-1.155-1.213-1.734-.807-1.162-1.63-2.312-2.42-3.485-.44-.651-.873-1.306-1.217-2.015a4.926 4.926 0 0 1-.49-1.677 7.885 7.885 0 0 1-.035-.68"
          fill={Primary}
        />
      </g>
    </SvgIcon>
  );
};

export const RentalIcon = () => {
  return (
    <SvgIcon width={size} height={size} fontSize={fontSize} viewBox={viewBoxValue}>
      <g transform="translate(2 2)" fill="none" fillRule="evenodd">
        <circle stroke={Primary} strokeWidth="3" fill="#FFF" cx="14" cy="14" r="14"/>
        <g fill={Primary} stroke="#FFF" strokeWidth=".2">
          <path
            d="M14.002 13.126h6.892c.105 0 .105 0 .105.109 0 2.138.002 4.276 0 6.414-.002.565-.26.981-.769 1.231-.184.09-.384.12-.59.12H8.358c-.459 0-.834-.176-1.109-.548a1.328 1.328 0 0 1-.247-.814v-5.904c0-.175.003-.351-.002-.526-.002-.07.02-.084.085-.084 1.358.002 2.716.002 4.074.002h2.843zM10.302 12.251l-3.175.001c-.068 0-.098-.007-.08-.085.013-.058.023-.116.042-.173l1.34-4.032c.167-.502.499-.822 1.02-.936a1.24 1.24 0 0 1 .266-.024c1.255 0 2.51 0 3.766-.002.069 0 .084.019.084.085-.002 1.693-.002 3.386 0 5.079 0 .07-.016.089-.088.089-1.058-.003-2.117-.002-3.175-.002M17.694 12.251c-1.053 0-2.106-.001-3.159.002-.085 0-.099-.024-.099-.102.003-1.685.003-3.37 0-5.055 0-.08.02-.096.097-.096 1.25.003 2.5-.001 3.75.003.514.002.907.228 1.168.674.05.087.086.18.117.275L20.915 12c.023.07.035.141.044.213.004.03-.005.04-.033.039H17.694"
          />
        </g>
      </g>
    </SvgIcon>
  );
};

export const ConfigIcon = () => {
  return (
    <SvgIcon width={size} height={size} fontSize={fontSize} viewBox={viewBoxValue}>
      <g transform="translate(2 2)" fill="none" fillRule="evenodd">
        <circle stroke={Primary} strokeWidth="3" fill="#FFF" cx="14" cy="14" r="14"/>
        <path
          d="M13.997 11.754c-1.484.001-2.694 1.231-2.696 2.74-.002 1.508 1.207 2.74 2.693 2.744 1.484.005 2.704-1.236 2.7-2.745-.004-1.51-1.214-2.74-2.697-2.739M11.84 7.406v-.772c.001-.23.123-.386.343-.435a8.518 8.518 0 0 1 2.27-.188c.453.022.9.09 1.343.183.234.049.359.206.36.453 0 .517 0 1.035-.002 1.553 0 .069.017.1.082.124a6.075 6.075 0 0 1 1.915 1.129c.048.04.08.026.123 0l1.234-.728c.04-.024.08-.049.121-.07.192-.102.382-.071.527.09a8.625 8.625 0 0 1 1.82 3.21c.066.208-.008.393-.203.508-.431.256-.863.51-1.298.76-.09.05-.113.1-.095.205.11.63.12 1.264.037 1.9-.01.07-.017.14-.029.21-.034.197-.046.15.118.247l1.253.736c.223.131.288.32.208.568a8.609 8.609 0 0 1-1.8 3.153c-.162.182-.336.21-.546.088a122.48 122.48 0 0 1-1.322-.776c-.07-.042-.112-.037-.173.015a6.39 6.39 0 0 1-1.866 1.098c-.078.03-.105.066-.104.151.004.504.002 1.009.002 1.513 0 .287-.11.414-.387.477a7.98 7.98 0 0 1-1.672.191 8.232 8.232 0 0 1-1.93-.204c-.214-.048-.325-.202-.325-.437a251.89 251.89 0 0 1 0-1.564c0-.062-.012-.096-.075-.119a6.145 6.145 0 0 1-1.902-1.112c-.054-.047-.092-.052-.155-.015-.435.26-.874.516-1.312.774-.22.13-.402.103-.572-.088a8.54 8.54 0 0 1-1.806-3.195.404.404 0 0 1 .18-.49c.449-.266.897-.531 1.349-.792.067-.039.084-.08.072-.152a6.467 6.467 0 0 1 0-2.2c.013-.076-.005-.12-.076-.162-.432-.248-.86-.502-1.29-.754-.246-.146-.303-.308-.216-.588a8.456 8.456 0 0 1 1.837-3.187c.123-.133.32-.154.497-.052.325.187.646.379.969.568.13.076.26.15.388.23.043.026.073.026.113-.008a6.382 6.382 0 0 1 1.917-1.128c.06-.022.08-.051.08-.116-.004-.267-.002-.535-.002-.802"
          fill={Primary}
        />
      </g>
    </SvgIcon>
  );
};

export const ClientIcon = () => {
  return (
    <SvgIcon width={size} height={size} fontSize={fontSize} viewBox={viewBoxValue}>
      <defs>
        <path id="5aelneb6da" d="M0 0h14v6.598H0z"/>
      </defs>
      <g transform="translate(2 2)" fill="none" fillRule="evenodd">
        <circle stroke={Primary} strokeWidth="3" fill="#FFF" cx="14" cy="14" r="14"/>
        <g transform="translate(7 14.479)">
          <mask id="1b4cbqrlbb" fill="#fff">
            <use xlinkHref="#5aelneb6da"/>
          </mask>
          <path
            d="M6.994 6.598H1.556c-.52 0-.946-.189-1.26-.585a1.263 1.263 0 0 1-.28-.771c-.01-.491-.032-.985.003-1.474C.122 2.314.855 1.22 2.195.49c.43-.234.896-.37 1.383-.444.372-.057.75-.044 1.125-.043.048 0 .088.025.13.042a5.698 5.698 0 0 0 4.328.005.635.635 0 0 1 .25-.048c.384 0 .77-.003 1.15.066.86.156 1.6.52 2.219 1.108a3.852 3.852 0 0 1 1.173 2.196c.033.192.047.387.046.582-.002.401.005.803-.002 1.204-.01.597-.295 1.039-.865 1.307a1.58 1.58 0 0 1-.681.134H6.994"
            fill={Primary} mask="url(#1b4cbqrlbb)"
          />
        </g>
        <path
          d="M10.008 9.766c.003-2.083 1.797-3.77 4.005-3.766 2.205.005 3.99 1.693 3.988 3.772-.003 2.084-1.796 3.77-4.004 3.766-2.206-.004-3.99-1.693-3.989-3.772"
          fill={Primary}
        />
      </g>
    </SvgIcon>
  );
};

export const DeliveryIcon = () => {
  return (
    <SvgIcon width={size} height={size} fontSize={fontSize} viewBox={viewBoxValue}>
      <g transform="translate(2 2)" fill="none" fillRule="evenodd">
        <circle stroke={Primary} strokeWidth="3" fill="#FFF" cx="14" cy="14" r="14"/>
        <path
          d="M18.752 16.775a1.277 1.277 0 0 0-1.278 1.268 1.277 1.277 0 0 0 1.272 1.281c.7.002 1.273-.566 1.278-1.268a1.277 1.277 0 0 0-1.272-1.281m-8.506 0a1.277 1.277 0 0 0-1.271 1.274c0 .704.576 1.278 1.278 1.275a1.277 1.277 0 0 0 1.272-1.274c0-.704-.576-1.278-1.279-1.275m8.711-2.975h1.692c.072 0 .167.031.212-.015.044-.045.009-.14.013-.212.003-.056-.004-.102-.05-.148-.852-.849-1.703-1.7-2.554-2.553a.149.149 0 0 0-.117-.048 61.35 61.35 0 0 1-1.015 0c-.07 0-.09.015-.09.089.002.934.002 1.867 0 2.8 0 .077.024.089.092.088.606-.002 1.211-.001 1.817-.001m-7.43-6.799c1.406 0 2.812-.003 4.218.002.546.001.947.254 1.188.746.086.173.117.363.116.557 0 .388.002.776-.001 1.164 0 .066.017.083.082.082.349-.003.698 0 1.046-.002a1.31 1.31 0 0 1 .975.403c.865.867 1.73 1.735 2.597 2.6.27.27.403.592.402.974-.003.913 0 1.826-.003 2.738 0 .07.017.09.087.086.11-.006.22-.003.33-.001a.43.43 0 0 1 .434.435c.002.278.003.556 0 .834a.429.429 0 0 1-.43.43c-.397.002-.793.002-1.19-.001-.065 0-.08.018-.083.082-.046.896-.44 1.602-1.2 2.075-.829.516-1.7.537-2.558.082-.69-.366-1.113-.957-1.285-1.72-.034-.149-.05-.3-.05-.453 0-.052-.016-.066-.067-.066-1.091.002-2.183.002-3.274 0-.055 0-.063.022-.064.069a2.49 2.49 0 0 1-.262 1.059c-.202.405-.49.736-.866.988a2.485 2.485 0 0 1-1.704.418 2.471 2.471 0 0 1-1.541-.76 2.49 2.49 0 0 1-.72-1.703c-.003-.063-.025-.07-.08-.071-.2-.001-.403.015-.603-.027A1.27 1.27 0 0 1 6 16.735v-8.42c0-.442.17-.804.528-1.07.205-.154.441-.227.695-.241.11-.006.22-.003.33-.003h3.975"
          fill={Primary}
        />
      </g>
    </SvgIcon>
  );
};

export const VerificationIcon = () => {
  return (
    <SvgIcon width={size} height={size} fontSize={fontSize} viewBox={viewBoxValue}>
      <g transform="translate(2 2)" fill="none" fillRule="evenodd">
        <circle stroke="#01B9E3" strokeWidth="3" fill="#FFF" cx="14" cy="14" r="14"/>
        <g fill={Primary}>
          <path
            d="M13.923 9.445a4.478 4.478 0 0 0-4.473 4.473 4.478 4.478 0 0 0 4.473 4.473 4.477 4.477 0 0 0 4.473-4.472 4.478 4.478 0 0 0-4.473-4.474m.268 10.438c-1.921-.004-3.476-.399-4.923-1.191-1.581-.866-2.835-2.081-3.785-3.612a9.632 9.632 0 0 1-.39-.688.984.984 0 0 1 0-.945 10.268 10.268 0 0 1 2.021-2.72A9.874 9.874 0 0 1 11.83 8.18a9.384 9.384 0 0 1 1.575-.21 9.582 9.582 0 0 1 4.223.721c.996.41 1.897.975 2.71 1.678a10.393 10.393 0 0 1 2.42 3.088.98.98 0 0 1-.007.937 10.238 10.238 0 0 1-3.327 3.78 9.687 9.687 0 0 1-3.773 1.555 9.232 9.232 0 0 1-1.46.154"
          />
          <path
            d="M11.061 13.135c.182.128.372.206.577.253.686.156 1.436-.25 1.683-.907.18-.48.125-.932-.143-1.363-.031-.05-.033-.063.029-.08.564-.157 1.122-.123 1.674.058.451.148.845.392 1.172.735.441.462.726 1.005.816 1.643.127.893-.11 1.686-.683 2.372a2.81 2.81 0 0 1-1.772.996c-.97.15-1.82-.116-2.54-.785a2.867 2.867 0 0 1-.859-1.57 2.883 2.883 0 0 1 .046-1.352"
          />
        </g>
      </g>
    </SvgIcon>
  );
};
